/* eslint-disable camelcase */
import React, { Component, Fragment } from 'react';
import { Modal, Form, Input, Row, Col, Select, Button } from 'antd';

class MenuItemModal extends Component {
  constructor(props) {
    super(props);
    const { initialValue } = props;
    this.state = {
      values: initialValue ? {
        title: initialValue.title || [],
        position: initialValue.position || 1,
      } : {
        title: [{
          lang: 'vi',
          value: '',
          url: '',
        }],
        position: 1,
      },
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { initialValue } = this.props;
    if (nextProps.initialValue !== initialValue) {
      this.setState({
        values: nextProps.initialValue ? {
          title: nextProps.initialValue.title || [],
          position: nextProps.initialValue.position || 1,
        } : {
          title: [{
            lang: 'vi',
            value: '',
            url: '',
          }],
          position: 1,
        },
      });
    }
  }

  handleUpdateField = (field, value) => {
    const { values } = this.state;
    this.setState({
      values: {
        ...values,
        [field]: value,
      },
    });
  }

  handleSubmit = () => {
    const { values } = this.state;
    const { onSubmit } = this.props;
    onSubmit(values);
    this.setState({
      values: {
        title: [{
          lang: 'vi',
          value: '',
          url: '',
        }],
        position: 1,
      },
    });
  }

  render() {
    const { visible, initialValue, onCancel, loading } = this.props;
    const { values } = this.state;
    return (
      <Fragment>
        <Modal
          visible={visible}
          title={initialValue ? 'Cập nhật' : 'Thêm mục con'}
          onCancel={() => {
            onCancel();
            this.setState({
              values: {
                title: [{
                  lang: 'vi',
                  value: '',
                  url: '',
                }],
                position: 1,
              },
            });
          }}
          onOk={this.handleSubmit}
          confirmLoading={loading}
          maskClosable={false}
          centered
        >
          <Form.Item label="Tiêu đề">
            {values.title.map((item, index) => (
              <Row key={index} gutter={16} style={{ width: '100%', marginBottom: 10 }}>
                <Col sm={values.title.length > 1 ? 7 : 8}>
                  <Select
                    style={{ width: '100%' }}
                    placeholder="Ngôn ngữ"
                    value={item.lang}
                    onChange={lang => this.setState({
                      values: {
                        ...values,
                        title: values.title.map((i, idx) => (idx === index ? ({
                          ...i,
                          lang,
                        }) : i)),
                      },
                    })}
                  >
                    <Select.Option value='vi' disabled={values.title.find((i, idx) => i.lang === 'vi' && idx !== index)}>Tiếng Việt</Select.Option>
                    <Select.Option value='en' disabled={values.title.find((i, idx) => i.lang === 'en' && idx !== index)}>Tiếng Anh</Select.Option>
                    {/* <Select.Option value='jp' disabled={values.title.find((i, idx) => i.lang === 'jp' && idx !== index)}>Tiếng Nhật</Select.Option> */}
                  </Select>
                </Col>
                <Col sm={8}>
                  <Input
                    style={{ width: '100%' }}
                    placeholder="Giá trị"
                    value={item.value}
                    onChange={e => this.setState({
                      values: {
                        ...values,
                        title: values.title.map((i, idx) => (idx === index ? ({
                          ...i,
                          value: e.target.value,
                        }) : i)),
                      },
                    })}
                  />
                </Col>
                <Col sm={8}>
                  <Input
                    style={{ width: '100%' }}
                    placeholder="Liên kết"
                    value={item.url}
                    onChange={e => this.setState({
                      values: {
                        ...values,
                        title: values.title.map((i, idx) => (idx === index ? ({
                          ...i,
                          url: e.target.value,
                        }) : i)),
                      },
                    })}
                  />
                </Col>
                {values.title.length > 1 && <Col sm={1}>
                  <Button
                    shape="circle" icon="close" onClick={() => this.setState({
                      values: {
                        ...values,
                        title: values.title.filter((_, idx) => idx !== index),
                      },
                    })}
                  />
                </Col>}
              </Row>
            ))}
            {values.title.length < 3 && <Button
              icon="plus" type="dashed" onClick={() => this.setState({
                values: {
                  ...values,
                  title: [...values.title, { lang: '', value: '', url: '' }],
                },
              })}
            >Thêm ngôn ngữ</Button>}
          </Form.Item>
          <Form.Item label="Ưu tiên">
            <Input
              type="number"
              value={values.position}
              onChange={e => this.handleUpdateField('position', e.target.value)}
              placeholder="1"
            />
          </Form.Item>
        </Modal>
      </Fragment>
    );
  }
}

export default MenuItemModal;



// WEBPACK FOOTER //
// ./src/screens/Dashboard/Categories/Governance/HomePage/Tabs/Menu/MenuItemModal.js